import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorkOrders = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_113_10779)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_113_10779",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				y: .218994,
				width: 24,
				height: 24,
				fill: "currentColor"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_113_10779)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.99998 21.3189C5.46798 21.3189 5.01831 21.1352 4.65098 20.7679C4.28364 20.4006 4.09998 19.9509 4.09998 19.4189V15.9344H6.49998V3.1189H19.9V19.1189C19.9 19.7342 19.6871 20.2547 19.2615 20.6804C18.8358 21.1061 18.3153 21.3189 17.7 21.3189H5.99998ZM17.6947 20.0189C17.9482 20.0189 18.1625 19.9326 18.3375 19.7601C18.5125 19.5876 18.6 19.3739 18.6 19.1189V4.4189H7.79998V15.9344H16.8V19.1189C16.8 19.3739 16.8857 19.5876 17.0572 19.7601C17.2287 19.9326 17.4412 20.0189 17.6947 20.0189ZM9.19223 8.91115V7.61115H17.2077V8.91115H9.19223ZM9.19223 11.7959V10.4959H17.2077V11.7959H9.19223ZM5.99998 20.0189H15.5V17.2341H5.39998V19.4189C5.39998 19.5889 5.45748 19.7314 5.57248 19.8464C5.68748 19.9614 5.82998 20.0189 5.99998 20.0189ZM5.99998 20.0189H5.39998H15.5H5.99998Z",
				fill: "currentColor"
			})
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_113_10779",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor",
			transform: "translate(0 0.218994)"
		})
	}) })]
});
export default SvgWorkOrders;
